<p-button
  (onClick)="openHelpTextDialog()"
  [outlined]="true"
  [rounded]="true"
  icon="pi pi-info"
  styleClass="custom-button"
  type="button"
  variant="outlined"
></p-button>

<p-dialog
  [(visible)]="dialogVisible"
  [draggable]="true"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '60rem', minHeight: '40rem' }"
  header="{{ 'help.helptext' | translate }}"
>
  <div [innerHTML]="contentValue" class="p-3"></div>
  <ng-template pTemplate="footer">
    <p-footer>
      <p-button (click)="dialogVisible = false" icon="pi pi-times" variant="outlined"
                label="{{ 'common.close' | translate }}"
                type="button"></p-button>
    </p-footer>
  </ng-template>
</p-dialog>
